import { IShip } from '../../../data/types/ship/ship';
import { hasEquipment } from '../../equipment/equipment';
import { FUEL_COMPACTOR } from '../../../data/types/ship/gadget/gadget-type';
import { getShipConfig } from '../../../config/ship/get-ship-config';

export const getFuelTanks = (ship: IShip): number =>
  hasEquipment(ship, FUEL_COMPACTOR) ? 18 : getShipConfig(ship).fuelTanks;
